const initServingNavigation = root => {
  if (!root || root.dataset.servingReady === 'true') return;

  const toggle = root.querySelector('[data-serving-toggle]');
  const panel = root.querySelector('[data-serving-panel]');
  if (!toggle || !panel) return;

  root.dataset.servingReady = 'true';
  const header = root.closest('.site-nav');
  const mobileToggle = header?.querySelector('.mobile-nav-toggle');
  const desktopQuery = window.matchMedia('(min-width: 1151px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  let closeTimer;
  let openedByHover = false;

  const isOpen = () => root.dataset.open === 'true';
  const clearCloseTimer = () => {
    window.clearTimeout(closeTimer);
    closeTimer = undefined;
  };
  const open = () => {
    clearCloseTimer();
    root.dataset.open = 'true';
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Hide Serving locations');
  };
  const close = ({ returnFocus = false } = {}) => {
    clearCloseTimer();
    openedByHover = false;
    root.dataset.open = 'false';
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Show Serving locations');
    if (returnFocus) toggle.focus();
  };
  const scheduleClose = () => {
    clearCloseTimer();
    closeTimer = window.setTimeout(() => {
      if (!root.matches(':hover') && !root.contains(document.activeElement)) close();
    }, 180);
  };

  toggle.addEventListener('click', event => {
    event.preventDefault();
    if (isOpen() && openedByHover && event.detail > 0) {
      openedByHover = false;
      clearCloseTimer();
      return;
    }
    openedByHover = false;
    isOpen() ? close() : open();
  });

  toggle.addEventListener('keydown', event => {
    if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    open();
    const links = [...panel.querySelectorAll('a[href]')];
    (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
  });

  root.addEventListener('pointerenter', event => {
    if (event.pointerType === 'touch' || !desktopQuery.matches || !hoverQuery.matches) return;
    if (!isOpen()) openedByHover = true;
    open();
  });

  root.addEventListener('pointerleave', event => {
    if (event.pointerType === 'touch' || !desktopQuery.matches || !hoverQuery.matches) return;
    scheduleClose();
  });

  root.addEventListener('focusin', clearCloseTimer);
  root.addEventListener('focusout', event => {
    if (!event.relatedTarget || root.contains(event.relatedTarget)) return;
    close();
  });

  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !isOpen()) return;
    event.preventDefault();
    close({ returnFocus: true });
  });

  panel.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });

  document.addEventListener('pointerdown', event => {
    if (isOpen() && !root.contains(event.target)) close();
  });

  mobileToggle?.addEventListener('click', () => {
    window.setTimeout(() => {
      if (mobileToggle.getAttribute('aria-expanded') !== 'true') close();
    }, 0);
  });

  desktopQuery.addEventListener?.('change', () => close());
};

const initAllServingNavigation = scope => {
  scope.querySelectorAll('[data-serving-nav]').forEach(initServingNavigation);
};

const bootServingNavigation = () => initAllServingNavigation(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootServingNavigation, { once: true });
} else {
  bootServingNavigation();
}

document.addEventListener('shopify:section:load', event => initAllServingNavigation(event.target));
